<template>
  <section>
    <h3 class="mobile-only">
      {{ t("lead.question_contact_mobile") }}
    </h3>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <label class="inbox-label ">{{
            t("lead.question_fullname")
          }}</label>
          <input
            id="fullname-txt"
            v-model="fullname"
            :fieldTitle="t('lead.question_fullname', {}, 'zh')"
            :fieldValue="fullname"
            fieldname="fullname"
            fieldType="name"
            name="fullname"
            type="text"
            class="form-control"
          />
        </div>
        <div class="col-sm-6 col-xs-12">
          <label class="inbox-label ">{{
            t("lead.question_phone")
          }}</label>
          <input
            v-model="mobile"
            :fieldTitle="t('lead.question_phone', {}, 'zh')"
            :fieldValue="mobile"
            fieldType="mobile"
            fieldname="mobile"
            fieldAttrs="unique"
            name="mobile"
            type="tel"
            maxlength="8"
            minlength="8"
            class="form-control"
            readonly=true
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <label class="inbox-label required">{{ t("common.email") }}</label>
          <input
            v-model="email"
            :fieldTitle="t('common.email', {}, 'zh')"
            :fieldValue="email"
            fieldname="email"
            fieldType="email"
            required
            name="email"
            type="email"
            class="form-control"
            id="id_email"
          />
        </div>
        <div
          v-if="type !== 'commercial_loan' && type != 'mortgage' && requireHKID"
          class="col-sm-6 col-xs-12"
        >
          <label class="inbox-label required">{{
            t("lead.question_id")
          }}</label>
          <input
            id="realIdentity"
            v-model="realIdentity"
            :placeholder="t('lead.question_id_tips')"
            :fieldTitle="t('lead.question_id', {}, 'zh')"
            fieldname="realIdentity"
            fieldType="hkid"
            fieldAttrs="unique"
            name="realIdentity"
            type="text"
            maxlength="9"
            minlength="8"
            class="form-control hkid-input"
            required
          />
        </div>
      </div>
    </div>
    <section v-if="type !== 'commercial_loan' && type !== 'mortgage'">
    <div class="form-group">
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <label class="inbox-label required">
            {{ t("register.birthdate") }}
          </label>
          <div class="row">
            <div class="col-4"><IntegerInput :label="t('application.employment_tenor_years')" v-model="birthdateYear" id="birthdate_year" @change="birthdateYearChange" required/></div>
            <div class="col-4"><IntegerInput :label="t('application.employment_tenor_months')" v-model="birthdateMonth" id="birthdate_month" @change="birthdateMonthChange" required/></div>
            <div class="col-4"><IntegerInput :label="t('application.employment_tenor_days')" v-model="birthdateDay" id="birthdate_day" @change="birthdateDayChange" required/></div>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12">
          <label class="inbox-label  d-block">
            {{ t("register.gender") }}
          </label>
          <div id="has-loan-radios" class="radio-group" style="margin-bottom: 0px;">
            <label class="btn-radio">
              <input
                  name="gender"
                  type="radio"
                  value="male"
                  fieldTitle="性別"
                  fieldName="gender"
                  v-model="gender"
                  :fieldValue="gender"
              />
              {{ t("register.male") }} </label
            ><label class="btn-radio">
            <input
                name="gender"
                type="radio"
                value="female"
                fieldTitle="性別"
                fieldName="gender"
                v-model="gender"
                :fieldValue="gender"
            />
            {{ t("register.female") }}
          </label>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label ">{{
              t("application.accommodation")
            }}</label>
          <v-select
              :options="accommodationOptions"
              :searchable="false"
              name="typeOfAccommodation"
              fieldTitle="居所類型"
              fieldName="typeOfAccommodation"
              v-model="typeOfAccommodation"
              :fieldValue="typeOfAccommodation ? typeOfAccommodation.value : ''"
          />
        </div>
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label ">{{
              t("application.personal_status")
            }}</label>
          <v-select
              :options="personalStatus"
              :searchable="false"
              name="personal-status"
              fieldTitle="婚姻狀況"
              fieldName="maritalStatus"
              v-model="maritalStatus"
              :fieldValue="maritalStatus ? maritalStatus.value : ''"
          />
        </div>
      </div>
    </div>
    </section>
    <Identity
      v-if="type !== 'commercial_loan' && refreshIdentity"
      :bornInHK="bornInHK"
      :permanent="permanent"
      :validityPeriod="validityPeriod"
      :showAge="showAge"
      :inviteCode="inviteCode"
    />
    <div v-if="type === 'commercial_loan'" class="col-sm-6 col-xs-12">
      <label class="inbox-label">{{ t("application.invitation_code") }}</label>
      <input
          id="invCode-txt"
          v-model="inviteCode"
          :fieldTitle="t('application.invitation_code', {}, 'zh')"
          :fieldValue="inviteCode"
          fieldname="inviteCode"
          name="inviteCode"
          type="text"
          maxlength="300"
          class="form-control"
      />
    </div>
    <input
        :value="age"
        type="hidden"
        name="age"
        fieldname="age"
    />
    <input
        :value="identity"
        type="hidden"
        name="identity"
        fieldname="identity"
    />
    <input
        id="id_birthdate"
        name="birth_date"
        type="hidden"
        class="form-control datepicker full-width"
        placeholder="yyyy-mm-dd"
        fieldTitle="出生日期"
        fieldName="birthdate"
        v-model="birthdate"
    />
  </section>
</template>
<script>
import commonFunc from "~/assets/js/commonHelper";
import Identity from "~/pages/application/components/Identity.vue";
import IntegerInput from "~/components/form/IntegerInput.vue";
export default {
  name: "Step4",
  components: {
    IntegerInput,
    Identity,
  },
  data: function () {
    return {
      type: "",
      requireHKID: true,
      fullname: "",
      email: "",
      mobile: "",
      realIdentity: "",
      identity: "",
      bornInHK: "",
      permanent: "",
      validityPeriod: "",
      age: 0,
      showAge: false,
      refreshIdentity: false,
      inviteCode: "",
      personalStatus: [],
      maritalStatus: {},
      birthdate: "",
      birthdateYear: "",
      birthdateMonth: "",
      birthdateDay: "",
      gender: "male",
      accommodationOptions: [],
      typeOfAccommodation: {},
    };
  },
  computed: {},
  mounted() {
    this.loadOptions();
    this.type = this.$route.query.type || "personal_loan";
    const token = this.$route.query.token || this.$route.query.key;
    if (token) {
      const applicationData = this.$store.state.search.applicationData;
      this.fullname = applicationData.fullname;
      this.mobile = applicationData.mobile;
      this.email = applicationData.email;
      this.realIdentity = applicationData.realIdentity;
      this.identity = applicationData.identity;
      this.age = applicationData.age;
      this.bornInHK = applicationData.bornInHk ? "yes" : "no";
      this.permanent = applicationData.hkPermanentResident ? "yes" : "no";
      this.validityPeriod = applicationData.visaValidityPeriod;
      this.inviteCode = applicationData.inviteCode;
      this.birthdate = applicationData.birthdate;
      if (applicationData.birthdate !== "") {
        const date = this.parseDate(applicationData.birthdate);
        this.birthdateYear = date.year;
        this.birthdateMonth = date.month;
        this.birthdateDay = date.day;
      }
      this.maritalStatus = applicationData.maritalStatus;
      this.typeOfAccommodation = applicationData.typeOfAccommodation;
    } else {
      const data = commonFunc.getLocalStorage("loan_info", true);
      if (data) {
        this.fullname = data.fullname;
        this.mobile = data.mobile;
        this.email = data.email;
        this.realIdentity = data.realIdentity;
        this.bornInHK = data.bornInHK;
        this.inviteCode = data.inviteCode;
        this.birthdate = data.birthdate;
        if (data.birthdate !== "") {
          const date = this.parseDate(data.birthdate);
          this.birthdateYear = date.year;
          this.birthdateMonth = date.month;
          this.birthdateDay = date.day;
        }
        this.maritalStatus = data.maritalStatus;
        this.typeOfAccommodation = data.typeOfAccommodation;
        this.permanent = data.permanent;
        this.validityPeriod = data.validityPeriod;
      }
    }
    this.refreshIdentity = true;
  },
  methods: {
    birthdateYearChange(val) {
      this.birthdateYear = parseInt(val);
    },
    birthdateMonthChange(val) {
      this.birthdateMonth = parseInt(val);
    },
    birthdateDayChange(val) {
      this.birthdateDay = parseInt(val);
    },
    beforeSubmit: function () {
      // ID validate
      if ($("#realIdentity").css('visibility') === "visible" &&
        this.requireHKID &&
        this.realIdentity !== "" &&
        !commonFunc.isHKID(this.realIdentity) &&
        this.type !== "commercial_loan"
      ) {
        commonFunc.toast(this.t("common.invalid_hkid"), "danger");
        $("#realIdentity").focus();
        return false;
      }
      if ($("#id_email").css('visibility') === "visible" &&
          !commonFunc.isValidEmail(this.email)) {
        commonFunc.toast(this.t('common.invalid_email'), 'danger');
        $("#id_email").focus();
        return false;
      }
      const errorBirthdateId = this.validateBirthdate("birthdate_year", "birthdate_month", "birthdate_day");
      if ($("#birthdate_year").css('visibility') === "visible" &&
          errorBirthdateId !== "") {
        commonFunc.toast(this.t('common.invalid_birthdate'), 'danger');
        $("#" + errorBirthdateId).focus();
        return false;
      }
      if (this.identity === "") {
        this.identity = commonFunc.convertIdentity(this.realIdentity);
      }
      this.birthdate = this.formatDate(this.birthdateYear, this.birthdateMonth, this.birthdateDay);
      this.age = this.calculateAge(this.birthdate);
      const data = commonFunc.getLocalStorage("loan_info", true) || {};
      data.fullname = this.fullname || "";
      data.mobile = this.mobile || "";
      data.email = this.email || "";
      data.realIdentity = this.realIdentity || "";
      data.bornInHK = this.bornInHK || "";
      data.inviteCode = this.inviteCode || "";
      data.birthdate = this.birthdate || "";
      data.maritalStatus = this.maritalStatus || "";
      data.typeOfAccommodation = this.typeOfAccommodation || "";
      data.permanent = this.permanent || "";
      data.validityPeriod = this.validityPeriod || "";
      commonFunc.setLocalStorage("loan_info", data, 3600 * 24 * 365, true);
      if (commonFunc.isMagicIdentity(this.realIdentity)) {
        this.realIdentity = this.identity;
      }
      return true;
    },
    parseDate: function(dateString) {
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      if (!regex.test(dateString)) {
        return {
          year: "",
          month: "",
          day: ""
        };
      }

      const parts = dateString.split('-');

      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);

      return {
        year: year,
        month: month,
        day: day
      };
    },
    formatDate: function(year, month, day) {
      const formattedMonth = String(month).padStart(2, '0');
      const formattedDay = String(day).padStart(2, '0');

      return `${year}-${formattedMonth}-${formattedDay}`;
    },
    validateBirthdate: function(yearInputId, monthInputId, dayInputId) {
      const year = parseInt(document.getElementById(yearInputId).value, 10);
      const month = parseInt(document.getElementById(monthInputId).value, 10);
      const day = parseInt(document.getElementById(dayInputId).value, 10);

      if (isNaN(year) || year <= 0) {
        return yearInputId;
      }

      if (isNaN(month) || month < 1 || month > 12) {
        return monthInputId;
      }

      const daysInMonth = [31, (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      if (isNaN(day) || day < 1 || day > daysInMonth[month - 1]) {
        return dayInputId;
      }

      const currentYear = new Date().getFullYear();
      const age = currentYear - year;
      if (age > 100) {
        return yearInputId;
      }

      return '';
    },
    loadOptions: function () {
      for (let i = 1; i <= 9; i++) {
        this.accommodationOptions.push({
          label: this.t("application.accommodation_option" + i),
          value: this.t("application.accommodation_option" + i, null, "zh"),
        });
      }
      for (let i = 1; i <= 3; i++) {
        this.personalStatus.push({
          label: this.t("application.personal_status_option" + i),
          value: this.t("application.personal_status_option" + i, null, "zh"),
        });
      }
    },
    calculateAge: function(birthDateString) {
      const today = new Date();
      const birthDate = new Date(birthDateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    validateDateFormat(dateString) {
      const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
      return regex.test(dateString);
    }
  },
};
</script>